import React from 'react'
import IconApp from '@svg/gnb/img_app_icon.svg'
import Link from 'next/link'
import {getLinkUrl, URL_HOME} from '@constant/url'

interface IProps {
    className?: string
}

const MobileNavTitle: React.FC<IProps> = ({className}) => {
    return (
        <div className={`${className}`}>
            <Link href={getLinkUrl(URL_HOME)}>
                <IconApp />
            </Link>
        </div>
    )
}

export default React.memo(MobileNavTitle)
